import { cmsUrl } from "../config";
import { useRouter } from "next/navigation";
import { Title } from "@/components/ui/typography";
import { cn } from "@/lib/utils";

export default function FeatureProduct({ productDetails, className }) {
  const router = useRouter();
  const featuredProduct = productDetails;

  return (
    <div
      className={cn(
        "relative  transition duration-500  overflow-hidden aspect-square",
        className
      )}
      style={{
        backgroundImage: `url(${cmsUrl}${featuredProduct?.image?.url})`,
        cursor: "pointer",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      onClick={() => {
        const url =
          featuredProduct?.promotionLink !== null
            ? `/${featuredProduct?.promotionLink}`
            : "/";
        router.push(url);
      }}
    >
      <div className="absolute p-[32px] bottom-0">
        <Title
          className={
            featuredProduct?.theme === "dark"
              ? "text-system-disabled"
              : "text-midnightIndigo-400"
          }
        >
          {featuredProduct?.promotionTitle}
        </Title>
      </div>
    </div>
  );
}
